/**
 * Match an order against a free-text query.
 * Strips non-digits from the query, then substring-matches against either
 * the order id or the customer phone. Empty query matches everything.
 */
export function matchesOrderQuery(
  order: { id: number; customerPhone: string },
  query: string,
): boolean {
  const trimmed = query.trim();
  if (!trimmed) return true;
  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return false;
  if (String(order.id).includes(digits)) return true;
  return Boolean(order.customerPhone?.includes(digits));
}
